import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22015344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-signup" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "page-main" }
const _hoisted_4 = { class: "page-title" }

import FormComponent from './components/form.vue';
  import JaFormComponent from './components/ja-form.vue';
  import { useRouter } from 'vue-router';
  import { useToast } from 'bootstrap-vue-3';
  import { authStore, userSurveysStore } from '@/stores';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const router = useRouter();
  const toast = useToast();

  async function handleSubmit(body: any) {
    await authStore.signUp(body);
    toast.show({ title: t('Tips'), body: t('Registration success') }, { variant: 'success' });
    router.replace({ name: 'home' });
    // 检查登录完成之后有没有问卷
    userSurveysStore.clearHistory();
    userSurveysStore.tryPopup('after_user_register');
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('Sign Up')), 1),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(locale) === 'ja' ? JaFormComponent : FormComponent ), { onSubmit: handleSubmit }))
      ])
    ])
  ]))
}
}

})